module.exports = __webpack_public_path__ + "static/media/summer_camp_thumb.5ba67359.jpg";